import { createContext, useContext } from 'react';

type ModalTitleContextValue = {
  /**
   * Id the modal points `aria-labelledby` at. `Modal.Title` puts it on its heading.
   */
  titleId: string;
  /**
   * Told whether a `Modal.Title` is currently rendered. The modal only references `titleId`
   * while one is: a reference to a missing element computes to an empty accessible name and
   * silently outranks `aria-label`, so a dangling reference is worse than no reference.
   */
  setHasTitle: (hasTitle: boolean) => void;
};

const ModalTitleContext = createContext<ModalTitleContextValue | undefined>(undefined);

export const ModalTitleContextProvider = ModalTitleContext.Provider;

/**
 * Not to be confused with `useModalContext` from `@/components/Modal/ModalContext`, which drives
 * the legacy modal system. This one only carries the id that names the dialog.
 */
export const useModalTitleContext = (): ModalTitleContextValue | undefined => useContext(ModalTitleContext);
